import {useLocation} from "react-router-dom";
import DiscoverLanding from "./discover-landing";
import LifeJourney from "./life-journey";
import type {DiscoverProps} from "./types";
import './discover.scss';

export default function Discover(props: DiscoverProps) {
    const location = useLocation();

    if (location.pathname === '/discover/life-journey') {
        return <LifeJourney {...props} />;
    }

    return <DiscoverLanding {...props} />;
}
